import { gql } from '@apollo/client';

import { BookmarkedSectionOverviewFragment } from 'approot/shared/bookmarks/bookmark.graphql';
import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';
import {
  studentAssessmentLandscapeImageFragment,
  studentAssessmentSquareImageFragment,
} from 'approot/student-assessment/student-assessment.graphql';
import { studentAssessmentWorksheetsFragment } from 'approot/student-assessment/sections/worksheets/worksheets.graphql';
import { studentAssessmentStimulusFragment } from 'approot/student-assessment/sections/stimulus/stimulus.graphql';
import { interactiveContentStyleBackgroundFragment } from 'approot/activity-builder/styles/styles.graphql';

export const GET_STUDENT_ASSESSMENT_ASSIGNMENT_BY_ID = gql`
  query GetStudentAssessmentAssignmentById(
    $input: GetStudentAssignmentByIdInput!
  ) {
    getStudentAssignmentById(input: $input) {
      id
      contentId
      isAssigned
      studentProgress
      isAutomarkable
      assignedContentData {
        ... on AssignedAssessmentData {
          stimulusResourceIds
          activitiesBookmarks {
            version
            sectionIds
          }
        }
      }
      linkedContent {
        ... on Assessment {
          id
          slug
          name
          authorId
          overviewJson
          integratedUnit {
            id
            name
          }
          subjects {
            id
            label
            name
            colour
          }
          years {
            name
          }
          unit {
            id
            name
          }
          ...StudentAssessmentLandscapeImageFragment
          ...StudentAssessmentSquareImageFragment
          ...StudentAssessmentWorksheetsFragment
          ...StudentAssessmentStimulusFragment
        }
      }
      assignedActivities {
        ... on AssessmentActivities {
          id
          language
          version
          downloadUrl
          printPdfKey
          availableTranslations
          assetKeys {
            print {
              language
              key
              publicToken
            }
            studentPrintables {
              language
              key
              publicToken
            }
          }
          assessmentName
          landscapeImage {
            alt
            ...ResponsiveImageFragment
          }
          styles {
            fontSize
            ...InteractiveContentStyleBackground
          }
          sectionsOverview {
            ...BookmarkedSectionOverviewFragment
          }
        }
      }
    }
  }
  ${BookmarkedSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
  ${ResponsiveImageFragment}
  ${studentAssessmentLandscapeImageFragment}
  ${studentAssessmentSquareImageFragment}
  ${studentAssessmentWorksheetsFragment}
  ${studentAssessmentStimulusFragment}
`;
